import { Routes, Route, BrowserRouter } from "react-router-dom";
import Start from "./onboard/Start";
import { AthleteStart } from "./athlete/AthleteStart";
import { CoachStart } from "./coach/CoachStart";
import { AthleteLogin } from "./athlete/login/AthleteLogin";
import { AthleteForgotPassword } from "./athlete/login/AthleteForgotPassword";
import { CoachLogin } from "./coach/login/CoachLogin";
import { CoachForgotPassword } from "./coach/login/CoachForgotPassword";
import { AthleteStep1 } from "./athlete/register/AthleteStep1";
import { AthleteStep2 } from "./athlete/register/AthleteStep2";
import AthleteStep3 from "./athlete/register/AthleteStep3";
import AthleteStep4 from "./athlete/register/AthleteStep4";
import AthleteStep5 from "./athlete/register/AthleteStep5";
import AthleteStep6 from "./athlete/register/AthleteStep6";
import { CoachStep1 } from "./coach/register/CoachStep1";
import { CoachStep2 } from "./coach/register/CoachStep2";
import CoachStep3 from "./coach/register/CoachStep3";
import CoachStep4 from "./coach/register/CoachStep4";
import { useAthleteAuthContext } from "./athlete/login/useAthleteAuthContext";
import { AthleteDashboard } from "./athlete/AthleteDashboard";
import { AthleteMySplit } from "./athlete/AthleteMySplit";
import { useCoachAuthContext } from "./coach/login/useCoachAuthContext";
import { CoachDashboard } from "./coach/CoachDashboard";
import { AthleteEditProfile } from "./athlete/AthleteEditProfile";
import { CoachMySplit } from "./coach/CoachMySplit";
import { CoachEditProfile } from "./coach/CoachEditProfile";
import { useStaffAuthContext } from "./administrator/staff/useStaffAuthContext";
import { StaffLogin } from "./administrator/staff/StaffLogin";
import { StaffDashboard } from "./administrator/staff/StaffDashboard";
import { CreateStaff } from "./administrator/staff/CreateStaff";
import { StaffManage } from "./administrator/staff/StaffManage";
import { AthleteManage } from "./administrator/athlete/AthleteManage";
import { CoachManage } from "./administrator/coach/CoachManage";
import { PhaseCreate } from "./administrator/warmup_routine/phase/PhaseCreate";
import { PhaseManage } from "./administrator/warmup_routine/phase/PhaseManage";
import { PhaseReorder } from "./administrator/warmup_routine/phase/PhaseReorder";
import { PhaseEdit } from "./administrator/warmup_routine/phase/PhaseEdit";
import { ExerciseCreate } from "./administrator/warmup_routine/exercise/ExerciseCreate";
import { ExerciseManage } from "./administrator/warmup_routine/exercise/ExerciseManage";
import { ExerciseEdit } from "./administrator/warmup_routine/exercise/ExerciseEdit";
import { AthleteWarmupRoutine } from "./administrator/athlete/AthleteWarmupRoutine";
import { AthleteWarmupRoutinePhase } from "./athlete/warmup_routine/AthleteWarmupRoutinePhase";
import { AthleteWarmupRoutineExercise } from "./athlete/warmup_routine/AthleteWarmupRoutineExercise";
import { AdminStaticWarmupRoutine } from "./administrator/static_warmup_routine/AdminStaticWarmupRoutine";
import { AthleteStaticWarmupRoutinePhase } from "./athlete/warmup_routine/AthleteStaticWarmupRoutinePhase";
import { AthleteStaticWarmupRoutineExercise } from "./athlete/warmup_routine/AthleteStaticWarmupRoutineExercise";
import { AthleteFreeWarmupRoutinePhase } from "./athlete/warmup_routine/AthleteFreeWarmupRoutinePhase";
import { AdminCreateStaticSpeedWorkout } from "./administrator/static_speed_workout/AdminCreateStaticSpeedWorkout";
import { AdminEditStaticSpeedWorkout } from "./administrator/static_speed_workout/AdminEditStaticSpeedWorkout";
import { AdminAthleteCreateDynamicSpeedWorkout } from "./administrator/athlete_dynamic_speed_workout/AdminAthleteCreateDynamicSpeedWorkout";
import { AdminAthleteEditDynamicSpeedWorkout } from "./administrator/athlete_dynamic_speed_workout/AdminAthleteEditDynamicSpeedWorkout";
import { AthleteFreeSpeedWorkout } from "./athlete/speed_workout/AthleteFreeSpeedWorkout";
import { AthleteStaticSpeedWorkout } from "./athlete/speed_workout/AthleteStaticSpeedWorkout";
import { AthleteStaticSpeedWorkoutSprints } from "./athlete/speed_workout/AthleteStaticSpeedWorkoutSprints";
import { AdminManageStaticWarmupRoutine } from "./administrator/static_warmup_routine/AdminManageStaticWarmupRoutine";
import { AdminEditStaticWarmupRoutine } from "./administrator/static_warmup_routine/AdminEditStaticWarmupRoutine";
import { AdminCreateStaticSpeedWorkoutTemplate } from "./administrator/static_speed_workout/AdminCreateStaticSpeedWorkoutTemplate";
import { AdminManageStaticSpeedWorkoutTemplate } from "./administrator/static_speed_workout/AdminManageStaticSpeedWorkoutTemplate";
import { AdminEditStaticSpeedWorkoutTemplate } from "./administrator/static_speed_workout/AdminEditStaticSpeedWorkoutTemplate";
import { AthleteStaticWarmupRoutineTemplateList } from "./athlete/warmup_routine/AthleteStaticWarmupRoutineTemplateList";
import { AthleteStaticSpeedWorkoutTemplateList } from "./athlete/speed_workout/AthleteStaticSpeedWorkoutTemplateList";
import { AthleteAmaxSpeedWorkout } from "./athlete/speed_workout/AthleteAmaxSpeedWorkout";
import { AthleteAmaxSpeedWorkoutSprints } from "./athlete/speed_workout/AthleteAmaxSpeedWorkoutSprints";
import { AdminManageStrengthExcercise } from "./administrator/strength_workout_exercise_library/AdminManageStrengthExercise";
import { AdminCreateStrengthExercise } from "./administrator/strength_workout_exercise_library/AdminCreateStrengthExercise";
import { AdminEditStrengthExercise } from "./administrator/strength_workout_exercise_library/AdminEditStrengthExercise";
import { AdminManageStaticStrengthTemplate } from "./administrator/static_strength_workout/AdminManageStaticStrengthTemplate";
import { AdminCreateStaticStrengthTemplate } from "./administrator/static_strength_workout/AdminCreateStaticStrengthTemplate";
import { AdminEditStaticStrengthTemplate } from "./administrator/static_strength_workout/AdminEditStaticStrengthTemplate";
import { AdminCreateStaticStrengthWorkout } from "./administrator/static_strength_workout/AdminCreateStaticStrengthWorkout";
import { AdminEditStaticStrengthWorkoutExercise } from "./administrator/static_strength_workout/AdminEditStaticStrengthWorkoutExercise";
import { AdminEditStaticStrengthWorkoutSuperset } from "./administrator/static_strength_workout/AdminEditStaticStrengthWorkoutSuperset";
import { AdminEditStaticStrengthWorkoutCircuit } from "./administrator/static_strength_workout/AdminEditStaticStrengthWorkoutCircuit";
import { AdminAthleteCreateDynamicStrengthWorkout } from "./administrator/athlete_dynamic_strength_workout/AdminAthleteCreateDynamicStrengthWorkout";
import { AdminAthleteEditDynamicStrengthWorkoutExercise } from "./administrator/athlete_dynamic_strength_workout/AdminAthleteEditDynamicStrengthWorkoutExercise";
import { AdminAthleteEditDynamicStrengthWorkoutSuperset } from "./administrator/athlete_dynamic_strength_workout/AdminAthleteEditDynamicStrengthWorkoutSuperset";
import { AdminAthleteEditDynamicStrengthWorkoutCircuit } from "./administrator/athlete_dynamic_strength_workout/AdminAthleteEditDynamicStrengthWorkoutCircuit";
import { AthleteFreeStrengthWorkout } from "./athlete/strength_workout/AthleteFreeStrengthWorkout";
import { AthleteStaticStrengthWorkoutTemplateList } from "./athlete/strength_workout/AthleteStaticStrengthWorkoutTemplateList";
import { AthleteStaticStrengthWorkout } from "./athlete/strength_workout/AthleteStaticStrengthWorkout";
import { AthleteStaticStrengthWorkoutList } from "./athlete/strength_workout/AthleteStaticStrengthWorkoutList";
import { AthleteStaticStrengthWorkoutExercise } from "./athlete/strength_workout/AthleteStaticStrengthWorkoutExercise";
import { AthleteAmaxStrengthWorkoutList } from "./athlete/strength_workout/AthleteAmaxStrengthWorkoutList";
import { AthleteAmaxStrengthWorkoutExercise } from "./athlete/strength_workout/AthleteAmaxStrengthWorkoutExercise";
import { AthleteEditWarmupRoutine } from "./administrator/athlete/AthleteEditWarmupRoutine";
import { AdminAthleteEdit } from "./administrator/athlete/AdminAthleteEdit";
import { AdminAthleteMessageManage } from "./administrator/athlete_message/AdminAthleteMessageManage";
import { AdminAthleteMessageReply } from "./administrator/athlete_message/AdminAthleteMessageReply";
import { AthleteMessages } from "./athlete/AthleteMessages";
import { AthleteTools } from "./athlete/purchase/AthleteTools";
import { AthletePurchaseStaticSpeedTemplates } from "./athlete/purchase/AthletePurchaseStaticSpeedTemplates";
import { AthletePurchaseStaticStrengthTemplates } from "./athlete/purchase/AthletePurchaseStaticStrengthTemplates";
import { AthleteStaticSpeedTemplateDetail } from "./athlete/purchase/AthleteStaticSpeedTemplateDetail";
import { AthleteStaticStrengthTemplateDetail } from "./athlete/purchase/AthleteStaticStrengthTemplateDetail";
import { AthletePurchaseTransactions } from "./athlete/purchase/AthletePurchaseTransactions";
import { AdminAthletePaymentTransactions } from "./administrator/athlete/AdminAthletePaymentTransactions";
import { AthletePurchaseRunrocketTool } from "./athlete/purchase/AthletePurchaseRunrocketTool";
import { AthleteRunrocketTestStep1 } from "./athlete/runrocket/AthleteRunrocketTestStep1";
import { AthleteRunrocketTestStep2 } from "./athlete/runrocket/AthleteRunrocketTestStep2";
import { AthleteRunrocketTestStep4 } from "./athlete/runrocket/AthleteRunrocketTestStep4";
import { AthleteRunrocketTestStep3 } from "./athlete/runrocket/AthleterunrocketTestStep3";
import { AthleteRunrocketTestResult } from "./athlete/runrocket/AthleteRunrocketTestResult";
import { AdminAthleteRunrocketTestTransactions } from "./administrator/athlete_runrocket/AthleteAdminRunrocketTestResult";
import { AdminManageRunrocketTrainingTemplate } from "./administrator/runrocket/AdminManageRunrocketTrainingTemplate";
import { AdminManageRunrocketTrainingTemplateData } from "./administrator/runrocket/AdminManageRunrocketTrainingTemplateData";
import { AdminRunrocketTrainingDataEdit } from "./administrator/runrocket/AdminRunrocketTrainingDataEdit";
import { AthleteRunrocketTrainingWeeks } from "./athlete/runrocket/AthleteRunrocketTrainingWeeks";
import { AthleteRunrocketTrainingDay } from "./athlete/runrocket/AthleteRunrocketTrainingDay";
import { AthleteRunrocketPerformance } from "./athlete/runrocket/AthleteRunrocketPerformance";
import { AthletePurchaseLoadvelocityTool } from "./athlete/purchase/AthletePurchaseLoadvelocityTool";
import { AdminAthleteLoadvelocityTestTransactions } from "./administrator/athlete_loadvelocity/AthleteAdminLoadvelocityTestResult";
import { AdminManageLoadvelocityTrainingTemplateData } from "./administrator/loadvelocity/AdminManageLoadvelocityTrainingTemplateData";
import { AdminManageLoadvelocityTrainingTemplate } from "./administrator/loadvelocity/AdminManageLoadvelocityTrainingTemplate";
import { AdminLoadvelocityTrainingDataEdit } from "./administrator/loadvelocity/AdminLoadvelocityTrainingDataEdit";
import { AthleteLoadvelocityTestStep1 } from "./athlete/loadvelocity/AthleteLoadvelocityTestStep1";
import { AthleteLoadvelocityTestStep2 } from "./athlete/loadvelocity/AthleteLoadvelocityTestStep2";
import { AthleteLoadvelocityTestStep3 } from "./athlete/loadvelocity/AthleteLoadvelocityTestStep3";
import { AthleteLoadvelocityTestStep4 } from "./athlete/loadvelocity/AthleteLoadvelocityTestStep4";
import { AthleteLoadvelocityTestResult } from "./athlete/loadvelocity/AthleteLoadvelocityTestResult";
import { AthleteLoadvelocityTrainingWeeks } from "./athlete/loadvelocity/AthleteLoadvelocityTrainingWeeks";
import { AthleteLoadvelocityTrainingDay } from "./athlete/loadvelocity/AthleteLoadvelocityTrainingDay";
import AthleteLoadvelocityPerformance from "./athlete/loadvelocity/AthleteLoadvelocityPerformance";
import { CoachFreeWarmupRoutinePhase } from "./coach/warmup_routine/CoachFreeWarmupRoutinePhase";
import { CoachFreeSpeedWorkout } from "./coach/speed_workout/CoachFreeSpeedWorkout";
import { CoachFreeStrengthWorkout } from "./coach/strength_workout/CoachFreeStrengthWorkout";
import { CoachTools } from "./coach/purchase/CoachTools";
import { CoachPurchaseStaticSpeedTemplates } from "./coach/purchase/CoachPurchaseStaticSpeedTemplates";
import { CoachPurchaseStaticStrengthTemplates } from "./coach/purchase/CoachPurchaseStaticStrengthTemplates";
import { CoachStaticSpeedTemplateDetail } from "./coach/purchase/CoachStaticSpeedTemplateDetail";
import { CoachStaticStrengthTemplateDetail } from "./coach/purchase/CoachStaticStrengthTemplateDetail";
import { CoachStaticSpeedWorkoutTemplateList } from "./coach/speed_workout/CoachStaticSpeedWorkoutTemplateList";
import { CoachStaticSpeedWorkout } from "./coach/speed_workout/CoachStaticSpeedWorkout";
import { CoachStaticSpeedWorkoutSprints } from "./coach/speed_workout/CoachStaticSpeedWorkoutSprints";
import { CoachStaticWarmupRoutinePhase } from "./coach/warmup_routine/CoachStaticWarmupRoutinePhase";
import { CoachStaticWarmupRoutineExercise } from "./coach/warmup_routine/CoachStaticWarmupRoutineExercise";
import { CoachPurchaseTransactions } from "./coach/purchase/CoachPurchaseTransactions";
import { CoachMessages } from "./coach/CoachMessages";
import { AdminCoachMessageManage } from "./administrator/coach_message/AdminCoachMessageManage";
import { AdminCoachMessageReply } from "./administrator/coach_message/AdminCoachMessageReply";
import { CoachStaticStrengthWorkoutTemplateList } from "./coach/strength_workout/CoachStaticStrengthWorkoutTemplateList";
import { CoachStaticStrengthWorkout } from "./coach/strength_workout/CoachStaticStrengthWorkout";
import { CoachStaticStrengthWorkoutList } from "./coach/strength_workout/CoachStaticStrengthWorkoutList";
import { CoachStaticStrengthWorkoutExercise } from "./coach/strength_workout/CoachStaticStrengthWorkoutExercise";
import { CoachPurchaseRunrocketTool } from "./coach/purchase/CoachPurchaseRunrocketTool";
import { CoachRunrocketTestStep1 } from "./coach/runrocket/CoachRunrocketTestStep1";
import { CoachRunrocketTestStep2 } from "./coach/runrocket/CoachRunrocketTestStep2";
import { CoachRunrocketTestStep3 } from "./coach/runrocket/CoachRunrocketTestStep3";
import { CoachRunrocketTestStep4 } from "./coach/runrocket/CoachRunrocketTestStep4";
import { CoachRunrocketTestResult } from "./coach/runrocket/CoachRunrocketTestResult";
import { CoachRunrocketTrainingWeeks } from "./coach/runrocket/CoachRunrocketTrainingWeeks";
import { CoachRunrocketTrainingDay } from "./coach/runrocket/CoachRunrocketTrainingDay";
import CoachRunrocketPerformance from "./coach/runrocket/CoachRunrocketPerformance";
import { CoachPurchaseLoadvelocityTool } from "./coach/purchase/CoachPurchaseLoadvelocityTool";
import { CoachLoadvelocityTestStep1 } from "./coach/loadvelocity/CoachLoadvelocityTestStep1";
import { CoachLoadvelocityTestStep2 } from "./coach/loadvelocity/CoachLoadvelocityTestStep2";
import { CoachLoadvelocityTestStep3 } from "./coach/loadvelocity/CoachLoadvelocityTestStep3";
import { CoachLoadvelocityTestStep4 } from "./coach/loadvelocity/CoachLoadvelocityTestStep4";
import { CoachLoadvelocityTestResult } from "./coach/loadvelocity/CoachLoadvelocityTestResult";
import { CoachLoadvelocityTrainingWeeks } from "./coach/loadvelocity/CoachLoadvelocityTrainingWeeks";
import { CoachLoadvelocityTrainingDay } from "./coach/loadvelocity/CoachLoadvelocityTrainingDay";
import CoachLoadvelocityPerformance from "./coach/loadvelocity/CoachLoadvelocityPerformance";
import { CoachAdminRunrocketTestResult } from "./administrator/coach_runrocket/CoachAdminRunrocketTestResult";
import { AdminCoachPaymentTransactions } from "./administrator/coach/AdminCoachPaymentTransactions";
import { CoachAdminLoadvelocityTestResult } from "./administrator/coach_loadvelocity/CoachAdminLoadvelocityTestResult";
import { AdminCoachEdit } from "./administrator/coach/AdminCoachEdit";
import { AdminManageExercise } from "./administrator/exercise_library/AdminManageExercise";
import { AdminCreateExercise } from "./administrator/exercise_library/AdminCreateExercise";
import { AdminEditExercise } from "./administrator/exercise_library/AdminEditExercise";
import { AdminManageWarmupRoutineTemplates } from "./administrator/template_speed/warmup-routine/AdminManageWarmupRoutineTemplates";
import { AdminEditWarmupRoutineTemplate } from "./administrator/template_speed/warmup-routine/AdminEditWarmupRoutineTemplate";
import { AdminManageSpeedTrainingFocusTemplates } from "./administrator/template_speed/training-focus/AdminManageSpeedTrainingFocusTemplates";
import { AdminEditSpeedTrainingFocusTemplate } from "./administrator/template_speed/training-focus/AdminEditSpeedTrainingFocusTemplate";
import { AdminManageSpeedTrainingTemplates } from "./administrator/template_speed/training-template/AdminManageSpeedTrainingTemplates";
import { AdminEditSpeedTrainingTemplate } from "./administrator/template_speed/training-template/AdminEditSpeedTrainingTemplate";
import { AdminManageSpeedTrainingProducts } from "./administrator/template_speed/products/AdminManageSpeedTrainingProducts";
import { AdminAthleteWarmupRoutine } from "./administrator/athlete_dashboard/AdminAthleteWarmupRoutine";
import { AdminAthleteSpeedWorkout } from "./administrator/athlete_dashboard/AdminAthlleteSpeedWorkout";
import { AdminManageStrengthTrainingProducts } from "./administrator/template_strength/products/AdminManageStrengthTrainingProducts";
import { AdminStrengthProductBuilder } from "./administrator/template_strength/products/AdminStrengthProductBuilder";
import { AdminManageStrengthTrainingFocusTemplates } from "./administrator/template_strength/training-focus/AdminManageStrengthTrainingFocusTemplates";
import { AdminEditStrengthTrainingFocusTemplate } from "./administrator/template_strength/training-focus/AdminEditStrengthTrainingFocusTemplate";
import { AdminAthleteStrengthWorkout } from "./administrator/athlete_dashboard/AdminAthleteStrengthWorkout";
import { AdminAthleteRunrocketResult } from "./administrator/athlete_dashboard/AdminAthleteRunrocketResult";
import { AdminAthleteLoadvelocityResult } from "./administrator/athlete_dashboard/AdminAthleteLoadvelocityResult";
import { AdminAthleteMessage } from "./administrator/athlete_dashboard/AdminAthleteMessage";
import { AthleteMembership } from "./athlete/membership/AthleteMembership";
import { AthletePurchasedSpeedProducts } from "./athlete/speed_product/AthletePurchasedSpeedProducts";
import { AthleteWarmupRoutinePhases } from "./athlete/speed_product/AthleteWarmupRoutinePhases";
import { AthleteWarmupRoutinePhaseExercises } from "./athlete/speed_product/AthleteWarmupRoutinePhaseExercises";
import { AthleteSpeedWorkout } from "./athlete/speed_product/AthleteSpeedWorkout";
import { AthleteSpeedWorkoutSprints } from "./athlete/speed_product/AthleteSpeedWorkoutSprints";
import { AthletePurchasedStrengthProducts } from "./athlete/strength_product/AthletePurchasedStrengthProducts";
import { AthleteStrengthWorkout } from "./athlete/strength_product/AthleteStrengthWorkout";
import { AthleteStrengthWorkoutList } from "./athlete/strength_product/AthleteStrengthWorkoutList";
import { AthleteStrengthWorkoutExercise } from "./athlete/strength_product/AthleteStrengthWorkoutExercise";
import { AthleteCoachedWarmupRoutinePhases } from "./athlete/speed_coached/AthleteCoachedWarmupRoutinePhases";
import { AthleteCoachedWarmupRoutinePhaseExercises } from "./athlete/speed_coached/AthleteCoachedWarmupRoutinePhaseExercises";
import { AthleteCoachedSpeedWorkout } from "./athlete/speed_coached/AthleteCoachedSpeedWorkout";
import { AthleteCoachedSpeedWorkoutSprints } from "./athlete/speed_coached/AthleteCoachedSpeedWorkoutSprints";
import { AthleteCoachedStrengthWorkout } from "./athlete/strength_coached/AthleteCoachedStrengthWorkout";
import { AthleteCoachedStrengthWorkoutList } from "./athlete/strength_coached/AthleteCoachedStrengthWorkoutList";
import AthleteCoachedStrengthWorkoutExercise from "./athlete/strength_coached/AthleteCoachedStrengthWorkoutExercise";
import AthleteCoachedPerformance from "./athlete/speed_coached/AthleteCoachedPerformance";
import { AdminAthleteSpeedPerformance } from "./administrator/athlete_dashboard/AdminAthleteSpeedPerformance";
import AdminAthleteSpeedPerformanceCharts from "./administrator/athlete_dashboard/AdminAthleteSpeedPerformanceCharts";
import NewFeatureTool from "./athlete/NewFeatureTool";
import { AthleteResetPassword } from "./athlete/login/AthleteResetPassword";
import AthleteStartNew from "./athlete/AthleteStartNew";

function App() {
  const { athlete } = useAthleteAuthContext();
  const { coach } = useCoachAuthContext();
  const { staff } = useStaffAuthContext();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AthleteStartNew />} />
        {/* <Route path="/" element={<Start />} /> */}
        <Route path="/athlete/newFeatureTool" element={<NewFeatureTool />} />


        <Route path="/athlete/start" element={<AthleteStart />} />
        <Route path="/athlete/login" element={<AthleteLogin />} />
        <Route
          path="/athlete/forgot-password"
          element={<AthleteForgotPassword />}
        />

        <Route
          path="/athlete/reset-password/:token"
          element={<AthleteResetPassword />}
        />

        <Route
          path="/athlete/dashboard"
          element={athlete ? <AthleteDashboard /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/membership"
          element={athlete ? <AthleteMembership /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/mysplit"
          element={athlete ? <AthleteMySplit /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/editprofile"
          element={athlete ? <AthleteEditProfile /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/warmup-routine/phase"
          element={athlete ? <AthleteWarmupRoutinePhase /> : <AthleteLogin />}
        />
        <Route
          path="/athlete/warmup-routine/phase-exercise/:phase_id/:record_id"
          element={
            athlete ? <AthleteWarmupRoutineExercise /> : <AthleteLogin />
          }
        />

        {/* Speed Products Related New Logic  */}

        <Route
          path="/athlete/speed-products"
          element={
            athlete ? <AthletePurchasedSpeedProducts /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/speed-product/warmup-routine-phases/:product_id"
          element={athlete ? <AthleteWarmupRoutinePhases /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/speed-product/warmup-routine-phase-exercises/:product_id"
          element={
            athlete ? <AthleteWarmupRoutinePhaseExercises /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/speed-product/speed-workout/:product_id"
          element={athlete ? <AthleteSpeedWorkout /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/speed-product/speed-workout/sprints/:product_id"
          element={athlete ? <AthleteSpeedWorkoutSprints /> : <AthleteLogin />}
        />

        {/* End Speed Products Related New Logic  */}

        {/* Strength Products related New Logic */}
        <Route
          path="/athlete/strength-products"
          element={
            athlete ? <AthletePurchasedStrengthProducts /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/strength-product/strength-workout/:product_id"
          element={athlete ? <AthleteStrengthWorkout /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/strength-product/strength-workout/day/:product_id"
          element={athlete ? <AthleteStrengthWorkoutList /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/strength-product/strength-workout/day/exercise/:product_id"
          element={
            athlete ? <AthleteStrengthWorkoutExercise /> : <AthleteLogin />
          }
        />

        {/* End of strength products related new logic */}

        {/* Speed coached related new logic */}

        <Route
          path="/athlete/coached/warmup-routine-phases"
          element={
            athlete ? <AthleteCoachedWarmupRoutinePhases /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/coached/warmup-routine-phase-exercises"
          element={
            athlete ? (
              <AthleteCoachedWarmupRoutinePhaseExercises />
            ) : (
              <AthleteLogin />
            )
          }
        />

        <Route
          path="/athlete/coached/speed-workout"
          element={athlete ? <AthleteCoachedSpeedWorkout /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/coached/speed-workout/sprints"
          element={
            athlete ? <AthleteCoachedSpeedWorkoutSprints /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/coached/performance"
          element={athlete ? <AthleteCoachedPerformance /> : <AthleteLogin />}
        />

        {/* end of speed coached related new logic */}

        {/* strength coached related new logic */}
        <Route
          path="/athlete/coached/strength-workout"
          element={
            athlete ? <AthleteCoachedStrengthWorkout /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/coached/strength-workout/day"
          element={
            athlete ? <AthleteCoachedStrengthWorkoutList /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/coached/strength-workout/day/exercise/:id"
          element={
            athlete ? (
              <AthleteCoachedStrengthWorkoutExercise />
            ) : (
              <AthleteLogin />
            )
          }
        />

        {/* end pf strength coached related new logic */}

        <Route
          path="/athlete/static-warmup-routine/phase/:warmup_id/:template_id"
          element={
            athlete ? <AthleteStaticWarmupRoutinePhase /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/static-warmup-routine/templates"
          element={
            athlete ? (
              <AthleteStaticWarmupRoutineTemplateList />
            ) : (
              <AthleteLogin />
            )
          }
        />

        <Route
          path="/athlete/static-warmup-routine/phase-exercise/:phase_id/:warmup_routine_id/:template_id"
          element={
            athlete ? <AthleteStaticWarmupRoutineExercise /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/free-warmup-routine/phase"
          element={
            athlete ? <AthleteFreeWarmupRoutinePhase /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/free-speed-workout"
          element={athlete ? <AthleteFreeSpeedWorkout /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/static-speed-workout/templates"
          element={
            athlete ? (
              <AthleteStaticSpeedWorkoutTemplateList />
            ) : (
              <AthleteLogin />
            )
          }
        />
        <Route
          path="/athlete/static-speed-workout/:template_id/:warmup_routine_id"
          element={athlete ? <AthleteStaticSpeedWorkout /> : <AthleteLogin />}
        />
        <Route
          path="/athlete/static-speed-workout/sprints/:theme_id/:warmup_routine_id/:template_id"
          element={
            athlete ? <AthleteStaticSpeedWorkoutSprints /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/amax-speed-workout/"
          element={athlete ? <AthleteAmaxSpeedWorkout /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/amax-speed-workout/sprints/:theme_id"
          element={
            athlete ? <AthleteAmaxSpeedWorkoutSprints /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/free-strength-workout"
          element={athlete ? <AthleteFreeStrengthWorkout /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/static-strength-workout/templates"
          element={
            athlete ? (
              <AthleteStaticStrengthWorkoutTemplateList />
            ) : (
              <AthleteLogin />
            )
          }
        />
        <Route
          path="/athlete/static-strength-workout/:template_id"
          element={
            athlete ? <AthleteStaticStrengthWorkout /> : <AthleteLogin />
          }
        />
        <Route
          path="/athlete/static-strength-workout/day/:day_id"
          element={
            athlete ? <AthleteStaticStrengthWorkoutList /> : <AthleteLogin />
          }
        />
        <Route
          path="/athlete/static-strength-workout/workout-exercise/:id/:type"
          element={
            athlete ? (
              <AthleteStaticStrengthWorkoutExercise />
            ) : (
              <AthleteLogin />
            )
          }
        />

        <Route
          path="/athlete/amax-strength-workout/"
          element={
            athlete ? <AthleteAmaxStrengthWorkoutList /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/amax-strength-workout/workout-exercise/:id/:type"
          element={
            athlete ? <AthleteAmaxStrengthWorkoutExercise /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/messages"
          element={athlete ? <AthleteMessages /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/tools"
          element={athlete ? <AthleteTools /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/purchase/static-speed-templates"
          element={
            athlete ? <AthletePurchaseStaticSpeedTemplates /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/purchase/static-strength-templates"
          element={
            athlete ? (
              <AthletePurchaseStaticStrengthTemplates />
            ) : (
              <AthleteLogin />
            )
          }
        />

        <Route
          path="/athlete/purchase/static-speed-template-detail/:id"
          element={
            athlete ? <AthleteStaticSpeedTemplateDetail /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/purchase/static-strength-template-detail/:id"
          element={
            athlete ? <AthleteStaticStrengthTemplateDetail /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/purchase-transactions"
          element={athlete ? <AthletePurchaseTransactions /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/purchase-astspeedprofile-tool"
          element={
            athlete ? <AthletePurchaseRunrocketTool /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/tools/runrocket/test/step1"
          element={athlete ? <AthleteRunrocketTestStep1 /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/tools/runrocket/test/step2"
          element={athlete ? <AthleteRunrocketTestStep2 /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/tools/runrocket/test/step3"
          element={athlete ? <AthleteRunrocketTestStep3 /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/tools/runrocket/test/step4"
          element={athlete ? <AthleteRunrocketTestStep4 /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/tools/runrocket/test/result"
          element={athlete ? <AthleteRunrocketTestResult /> : <AthleteLogin />}
        />
        <Route
          path="/athlete/tools/runrocket/training-weeks/:template_id"
          element={
            athlete ? <AthleteRunrocketTrainingWeeks /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/tools/runrocket/training/week-day/:week_day/:day_id"
          element={athlete ? <AthleteRunrocketTrainingDay /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/tools/runrocket/performance/:template_id"
          element={athlete ? <AthleteRunrocketPerformance /> : <AthleteLogin />}
        />

        <Route
          path="/athlete/purchase-loadvelocity-tool"
          element={
            athlete ? <AthletePurchaseLoadvelocityTool /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/tools/loadvelocity/test/step1"
          element={
            athlete ? <AthleteLoadvelocityTestStep1 /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/tools/loadvelocity/test/step2"
          element={
            athlete ? <AthleteLoadvelocityTestStep2 /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/tools/loadvelocity/test/step3"
          element={
            athlete ? <AthleteLoadvelocityTestStep3 /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/tools/loadvelocity/test/step4"
          element={
            athlete ? <AthleteLoadvelocityTestStep4 /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/tools/loadvelocity/test/result"
          element={
            athlete ? <AthleteLoadvelocityTestResult /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/tools/loadvelocity/training-weeks/:template_id"
          element={
            athlete ? <AthleteLoadvelocityTrainingWeeks /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/tools/loadvelocity/training/week-day/:week_day/:day_id"
          element={
            athlete ? <AthleteLoadvelocityTrainingDay /> : <AthleteLogin />
          }
        />

        <Route
          path="/athlete/tools/loadvelocity/performance/:template_id"
          element={
            athlete ? <AthleteLoadvelocityPerformance /> : <AthleteLogin />
          }
        />

        <Route path="/athlete/register/step1" element={<AthleteStep1 />} />
        <Route path="/athlete/register/step2" element={<AthleteStep2 />} />
        <Route path="/athlete/register/step3" element={<AthleteStep3 />} />
        <Route path="/athlete/register/step4" element={<AthleteStep4 />} />
        <Route path="/athlete/register/step5" element={<AthleteStep5 />} />
        <Route path="/athlete/register/step6" element={<AthleteStep6 />} />

        <Route path="/coach/start" element={<CoachStart />} />
        <Route path="/coach/login" element={<CoachLogin />} />
        <Route
          path="/coach/forgot-password"
          element={<CoachForgotPassword />}
        />
        <Route
          path="/coach/dashboard"
          element={coach ? <CoachDashboard /> : <CoachLogin />}
        />

        <Route
          path="/coach/mysplit"
          element={coach ? <CoachMySplit /> : <CoachLogin />}
        />

        <Route
          path="/coach/editprofile"
          element={coach ? <CoachEditProfile /> : <CoachLogin />}
        />

        <Route
          path="/coach/free-warmup-routine/phase"
          element={coach ? <CoachFreeWarmupRoutinePhase /> : <CoachLogin />}
        />

        <Route
          path="/coach/free-speed-workout"
          element={coach ? <CoachFreeSpeedWorkout /> : <CoachLogin />}
        />

        <Route
          path="/coach/static-speed-workout/templates"
          element={
            coach ? <CoachStaticSpeedWorkoutTemplateList /> : <CoachLogin />
          }
        />
        <Route
          path="/coach/static-speed-workout/:template_id/:warmup_routine_id"
          element={coach ? <CoachStaticSpeedWorkout /> : <CoachLogin />}
        />
        <Route
          path="/coach/static-speed-workout/sprints/:theme_id/:warmup_routine_id/:template_id"
          element={coach ? <CoachStaticSpeedWorkoutSprints /> : <CoachLogin />}
        />

        <Route
          path="/coach/static-warmup-routine/phase/:warmup_id/:template_id"
          element={coach ? <CoachStaticWarmupRoutinePhase /> : <CoachLogin />}
        />

        <Route
          path="/coach/static-warmup-routine/phase-exercise/:phase_id/:warmup_routine_id/:template_id"
          element={
            coach ? <CoachStaticWarmupRoutineExercise /> : <CoachLogin />
          }
        />

        <Route
          path="/coach/free-strength-workout"
          element={coach ? <CoachFreeStrengthWorkout /> : <CoachLogin />}
        />

        <Route
          path="/coach/static-strength-workout/templates"
          element={
            coach ? <CoachStaticStrengthWorkoutTemplateList /> : <CoachLogin />
          }
        />
        <Route
          path="/coach/static-strength-workout/:template_id"
          element={coach ? <CoachStaticStrengthWorkout /> : <CoachLogin />}
        />
        <Route
          path="/coach/static-strength-workout/day/:day_id"
          element={coach ? <CoachStaticStrengthWorkoutList /> : <CoachLogin />}
        />
        <Route
          path="/coach/static-strength-workout/workout-exercise/:id/:type"
          element={
            coach ? <CoachStaticStrengthWorkoutExercise /> : <CoachLogin />
          }
        />

        <Route
          path="/coach/tools"
          element={coach ? <CoachTools /> : <CoachLogin />}
        />

        <Route
          path="/coach/purchase/static-speed-templates"
          element={
            coach ? <CoachPurchaseStaticSpeedTemplates /> : <CoachLogin />
          }
        />

        <Route
          path="/coach/purchase/static-strength-templates"
          element={
            coach ? <CoachPurchaseStaticStrengthTemplates /> : <CoachLogin />
          }
        />

        <Route
          path="/coach/purchase/static-speed-template-detail/:id"
          element={coach ? <CoachStaticSpeedTemplateDetail /> : <CoachLogin />}
        />

        <Route
          path="/coach/purchase/static-strength-template-detail/:id"
          element={
            coach ? <CoachStaticStrengthTemplateDetail /> : <CoachLogin />
          }
        />

        <Route
          path="/coach/purchase-transactions"
          element={coach ? <CoachPurchaseTransactions /> : <CoachLogin />}
        />

        <Route
          path="/coach/messages"
          element={coach ? <CoachMessages /> : <CoachLogin />}
        />

        <Route
          path="/coach/purchase-runrocket-tool"
          element={coach ? <CoachPurchaseRunrocketTool /> : <CoachLogin />}
        />

        <Route
          path="/coach/tools/runrocket/test/step1"
          element={coach ? <CoachRunrocketTestStep1 /> : <CoachLogin />}
        />

        <Route
          path="/coach/tools/runrocket/test/step2"
          element={coach ? <CoachRunrocketTestStep2 /> : <CoachLogin />}
        />

        <Route
          path="/coach/tools/runrocket/test/step3"
          element={coach ? <CoachRunrocketTestStep3 /> : <CoachLogin />}
        />

        <Route
          path="/coach/tools/runrocket/test/step4"
          element={coach ? <CoachRunrocketTestStep4 /> : <CoachLogin />}
        />

        <Route
          path="/coach/tools/runrocket/test/result"
          element={coach ? <CoachRunrocketTestResult /> : <CoachLogin />}
        />
        <Route
          path="/coach/tools/runrocket/training-weeks/:template_id"
          element={coach ? <CoachRunrocketTrainingWeeks /> : <CoachLogin />}
        />

        <Route
          path="/coach/tools/runrocket/training/week-day/:week_day/:day_id"
          element={coach ? <CoachRunrocketTrainingDay /> : <CoachLogin />}
        />

        <Route
          path="/coach/tools/runrocket/performance/:template_id"
          element={coach ? <CoachRunrocketPerformance /> : <CoachLogin />}
        />

        <Route
          path="/coach/purchase-loadvelocity-tool"
          element={coach ? <CoachPurchaseLoadvelocityTool /> : <CoachLogin />}
        />

        <Route
          path="/coach/tools/loadvelocity/test/step1"
          element={coach ? <CoachLoadvelocityTestStep1 /> : <CoachLogin />}
        />

        <Route
          path="/coach/tools/loadvelocity/test/step2"
          element={coach ? <CoachLoadvelocityTestStep2 /> : <CoachLogin />}
        />

        <Route
          path="/coach/tools/loadvelocity/test/step3"
          element={coach ? <CoachLoadvelocityTestStep3 /> : <CoachLogin />}
        />

        <Route
          path="/coach/tools/loadvelocity/test/step4"
          element={coach ? <CoachLoadvelocityTestStep4 /> : <CoachLogin />}
        />

        <Route
          path="/coach/tools/loadvelocity/test/result"
          element={coach ? <CoachLoadvelocityTestResult /> : <CoachLogin />}
        />

        <Route
          path="/coach/tools/loadvelocity/training-weeks/:template_id"
          element={coach ? <CoachLoadvelocityTrainingWeeks /> : <CoachLogin />}
        />

        <Route
          path="/coach/tools/loadvelocity/training/week-day/:week_day/:day_id"
          element={coach ? <CoachLoadvelocityTrainingDay /> : <CoachLogin />}
        />

        <Route
          path="/coach/tools/loadvelocity/performance/:template_id"
          element={coach ? <CoachLoadvelocityPerformance /> : <CoachLogin />}
        />

        <Route path="/coach/register/step1" element={<CoachStep1 />} />
        <Route path="/coach/register/step2" element={<CoachStep2 />} />
        <Route path="/coach/register/step3" element={<CoachStep3 />} />
        <Route path="/coach/register/step4" element={<CoachStep4 />} />

        <Route path="/administrator/login" element={<StaffLogin />} />
        <Route
          path="/administrator/dashboard"
          element={staff ? <StaffDashboard /> : <StaffLogin />}
        />
        <Route
          path="/administrator/staff/create"
          element={staff ? <CreateStaff /> : <StaffLogin />}
        />

        <Route
          path="/administrator/staff/manage"
          element={staff ? <StaffManage /> : <StaffLogin />}
        />

        <Route
          path="/administrator/athlete/manage"
          element={staff ? <AthleteManage /> : <StaffLogin />}
        />

        <Route
          path="/administrator/athlete/edit/:athlete_id"
          element={staff ? <AdminAthleteEdit /> : <StaffLogin />}
        />

        <Route
          path="/administrator/athlete/warmup-routine/:athlete_id"
          element={staff ? <AdminAthleteWarmupRoutine /> : <StaffLogin />}
        />

        {/* Athlete speed workout  */}
        <Route
          path="/administrator/athlete/speed-workout/:athlete_id"
          element={staff ? <AdminAthleteSpeedWorkout /> : <StaffLogin />}
        />

        <Route
          path="/administrator/athlete/speed-performance/:athlete_id"
          element={staff ? <AdminAthleteSpeedPerformance /> : <StaffLogin />}
        />

        <Route
          path="/administrator/athlete/speed-charts/:athlete_id"
          element={
            staff ? <AdminAthleteSpeedPerformanceCharts /> : <StaffLogin />
          }
        />

        {/* Athlete strength workout  */}
        <Route
          path="/administrator/athlete/strength-workout/:athlete_id"
          element={staff ? <AdminAthleteStrengthWorkout /> : <StaffLogin />}
        />

        {/* Athlete runrocket result dashboard  */}
        <Route
          path="/administrator/athlete/runrocket-result/:athlete_id"
          element={staff ? <AdminAthleteRunrocketResult /> : <StaffLogin />}
        />

        {/* Athlete loadvelocity result dashboard  */}
        <Route
          path="/administrator/athlete/loadvelocity-result/:athlete_id"
          element={staff ? <AdminAthleteLoadvelocityResult /> : <StaffLogin />}
        />

        {/* Athlete message dashboard  */}
        <Route
          path="/administrator/athlete/message/:athlete_id"
          element={staff ? <AdminAthleteMessage /> : <StaffLogin />}
        />

        {/* Athlete RR */}

        <Route
          path="/administrator/coach/manage"
          element={staff ? <CoachManage /> : <StaffLogin />}
        />

        {/* ADMIN EXERCISE LIBRARY ROUTES - START */}
        <Route
          path="/administrator/exercise-library/manage"
          element={staff ? <AdminManageExercise /> : <StaffLogin />}
        />

        <Route
          path="/administrator/exercise-library/create"
          element={staff ? <AdminCreateExercise /> : <StaffLogin />}
        />

        <Route
          path="/administrator/exercise-library/edit/:id"
          element={staff ? <AdminEditExercise /> : <StaffLogin />}
        />
        {/* ADMIN EXERCISE LIBRARY ROUTES - END */}

        {/* ADMIN TEMPLATE SPEED - WARMUP-ROUTINE ROUTES - START */}
        <Route
          path="/administrator/template-speed/warmup-routine/manage"
          element={
            staff ? <AdminManageWarmupRoutineTemplates /> : <StaffLogin />
          }
        />
        <Route
          path="/administrator/template-speed/warmup-routine/edit/:template_id"
          element={staff ? <AdminEditWarmupRoutineTemplate /> : <StaffLogin />}
        />

        {/* ADMIN TEMPLATE SPEED - WARMUP-ROUTINE ROUTES - END */}

        {/* ADMIN TEMPLATE SPEED - TRAINING FOCUS - START */}
        <Route
          path="/administrator/template-speed/training-focus/manage"
          element={
            staff ? <AdminManageSpeedTrainingFocusTemplates /> : <StaffLogin />
          }
        />

        <Route
          path="/administrator/template-speed/training-focus/edit/:template_id"
          element={
            staff ? <AdminEditSpeedTrainingFocusTemplate /> : <StaffLogin />
          }
        />

        <Route
          path="/administrator/template-speed/training-template/manage"
          element={
            staff ? <AdminManageSpeedTrainingTemplates /> : <StaffLogin />
          }
        />

        <Route
          path="/administrator/template-speed/training-template/edit/:template_id"
          element={staff ? <AdminEditSpeedTrainingTemplate /> : <StaffLogin />}
        />

        {/* ADMIN TEMPLATE SPEED - WORKOUT ROUTES - END */}

        {/* ADMIN TEMPLATE SPEED - PRODUCTS - START */}
        <Route
          path="/administrator/template-speed/products/manage"
          element={
            staff ? <AdminManageSpeedTrainingProducts /> : <StaffLogin />
          }
        />

        {/* ADMIN TEMPLATE SPEED - PRODUCTS END */}

        {/* ADMIN TEMPLATE STRENGTH - PRODUCTS START */}
        <Route
          path="/administrator/template-strength/products/manage"
          element={
            staff ? <AdminManageStrengthTrainingProducts /> : <StaffLogin />
          }
        />

        <Route
          path="/administrator/template-strength/workout-builder/:template_id"
          element={staff ? <AdminStrengthProductBuilder /> : <StaffLogin />}
        />

        <Route
          path="/administrator/template-strength/training-focus/manage"
          element={
            staff ? (
              <AdminManageStrengthTrainingFocusTemplates />
            ) : (
              <StaffLogin />
            )
          }
        />

        <Route
          path="/administrator/template-strength/training-focus/edit/:template_id"
          element={
            staff ? <AdminEditStrengthTrainingFocusTemplate /> : <StaffLogin />
          }
        />

        {/* ADMIN TEMPLATE STRENGTH - PRODUCTS END */}

        <Route
          path="/administrator/warmup-routine/create-phase"
          element={staff ? <PhaseCreate /> : <StaffLogin />}
        />

        <Route
          path="/administrator/warmup-routine/manage-phase"
          element={staff ? <PhaseManage /> : <StaffLogin />}
        />
        <Route
          path="/administrator/warmup-routine/reorder-phase"
          element={staff ? <PhaseReorder /> : <StaffLogin />}
        />
        <Route
          path="/administrator/warmup-routine/edit-phase/:id"
          element={staff ? <PhaseEdit /> : <StaffLogin />}
        />
        <Route
          path="/administrator/warmup-routine/create-phase-exercise/:phase_id"
          element={staff ? <ExerciseCreate /> : <StaffLogin />}
        />

        <Route
          path="/administrator/warmup-routine/manage-phase-exercise/:phase_id"
          element={staff ? <ExerciseManage /> : <StaffLogin />}
        />

        <Route
          path="/administrator/warmup-routine/edit-phase-exercise/:phase_id/:id"
          element={staff ? <ExerciseEdit /> : <StaffLogin />}
        />

        {/* Athlete warmup routine old*/}
        <Route
          path="/administrator/athlete/warmup-routine/:athlete_id"
          element={staff ? <AthleteWarmupRoutine /> : <StaffLogin />}
        />

        <Route
          path="/athlete/warmup-routine/edit/:record_id"
          element={staff ? <AthleteEditWarmupRoutine /> : <AthleteLogin />}
        />

        <Route
          path="/administrator/warmup-routine/static/create"
          element={staff ? <AdminStaticWarmupRoutine /> : <StaffLogin />}
        />
        <Route
          path="/administrator/warmup-routine/static/manage"
          element={staff ? <AdminManageStaticWarmupRoutine /> : <StaffLogin />}
        />
        <Route
          path="/administrator/warmup-routine/static/edit/:warmup_id"
          element={staff ? <AdminEditStaticWarmupRoutine /> : <StaffLogin />}
        />

        <Route
          path="/administrator/static-speed-workout/create-template"
          element={
            staff ? <AdminCreateStaticSpeedWorkoutTemplate /> : <StaffLogin />
          }
        />

        <Route
          path="/administrator/static-speed-workout/manage-template"
          element={
            staff ? <AdminManageStaticSpeedWorkoutTemplate /> : <StaffLogin />
          }
        />

        <Route
          path="/administrator/static-speed-workout/edit-template/:template_id"
          element={
            staff ? <AdminEditStaticSpeedWorkoutTemplate /> : <StaffLogin />
          }
        />

        <Route
          path="/administrator/static-speed-workout/create/:template_id"
          element={staff ? <AdminCreateStaticSpeedWorkout /> : <StaffLogin />}
        />
        <Route
          path="/administrator/static-speed-workout/edit/:workout_id/:theme_id"
          element={staff ? <AdminEditStaticSpeedWorkout /> : <StaffLogin />}
        />
        <Route
          path="/administrator/athlete/speed-workout/create/:athlete_id"
          element={
            staff ? <AdminAthleteCreateDynamicSpeedWorkout /> : <StaffLogin />
          }
        />
        <Route
          path="/administrator/athlete/speed-workout/edit/:athlete_id/:theme_id"
          element={
            staff ? <AdminAthleteEditDynamicSpeedWorkout /> : <StaffLogin />
          }
        />

        <Route
          path="/administrator/static-strength-workout/manage-exercise"
          element={staff ? <AdminManageStrengthExcercise /> : <StaffLogin />}
        />

        <Route
          path="/administrator/static-strength-workout/create-exercise"
          element={staff ? <AdminCreateStrengthExercise /> : <StaffLogin />}
        />
        <Route
          path="/administrator/static-strength-workout/edit-exercise/:exercise_id"
          element={staff ? <AdminEditStrengthExercise /> : <StaffLogin />}
        />

        <Route
          path="/administrator/static-strength-workout/manage-template"
          element={
            staff ? <AdminManageStaticStrengthTemplate /> : <StaffLogin />
          }
        />

        <Route
          path="/administrator/static-strength-workout/create-template"
          element={
            staff ? <AdminCreateStaticStrengthTemplate /> : <StaffLogin />
          }
        />

        <Route
          path="/administrator/static-strength-workout/edit-template/:template_id"
          element={staff ? <AdminEditStaticStrengthTemplate /> : <StaffLogin />}
        />

        <Route
          path="/administrator/static-strength-workout/create/:template_id"
          element={
            staff ? <AdminCreateStaticStrengthWorkout /> : <StaffLogin />
          }
        />

        <Route
          path="/administrator/static-strength-workout/edit/exercise/:id/:template_id"
          element={
            staff ? <AdminEditStaticStrengthWorkoutExercise /> : <StaffLogin />
          }
        />

        <Route
          path="/administrator/static-strength-workout/edit/superset/:id/:template_id"
          element={
            staff ? <AdminEditStaticStrengthWorkoutSuperset /> : <StaffLogin />
          }
        />

        <Route
          path="/administrator/static-strength-workout/edit/circuit/:id/:template_id"
          element={
            staff ? <AdminEditStaticStrengthWorkoutCircuit /> : <StaffLogin />
          }
        />

        <Route
          path="/administrator/dynamic-strength-workout/create/:athlete_id"
          element={
            staff ? (
              <AdminAthleteCreateDynamicStrengthWorkout />
            ) : (
              <StaffLogin />
            )
          }
        />

        <Route
          path="/administrator/dynamic-strength-workout/edit/exercise/:id/:athlete_id"
          element={
            staff ? (
              <AdminAthleteEditDynamicStrengthWorkoutExercise />
            ) : (
              <StaffLogin />
            )
          }
        />

        <Route
          path="/administrator/dynamic-strength-workout/edit/superset/:id/:athlete_id"
          element={
            staff ? (
              <AdminAthleteEditDynamicStrengthWorkoutSuperset />
            ) : (
              <StaffLogin />
            )
          }
        />
        <Route
          path="/administrator/dynamic-strength-workout/edit/circuit/:id/:athlete_id"
          element={
            staff ? (
              <AdminAthleteEditDynamicStrengthWorkoutCircuit />
            ) : (
              <StaffLogin />
            )
          }
        />

        <Route
          path="/administrator/message/manage-athlete-message"
          element={staff ? <AdminAthleteMessageManage /> : <StaffLogin />}
        />

        <Route
          path="/administrator/message/manage-coach-message"
          element={staff ? <AdminCoachMessageManage /> : <StaffLogin />}
        />

        <Route
          path="/administrator/message/athlete-reply/:message_id"
          element={staff ? <AdminAthleteMessageReply /> : <StaffLogin />}
        />

        <Route
          path="/administrator/message/coach-reply/:message_id"
          element={staff ? <AdminCoachMessageReply /> : <StaffLogin />}
        />

        <Route
          path="/administrator/athlete/payment-transactions/:athlete_id"
          element={staff ? <AdminAthletePaymentTransactions /> : <StaffLogin />}
        />

        <Route
          path="/administrator/athlete/runrocket/test-results/:athlete_id"
          element={
            staff ? <AdminAthleteRunrocketTestTransactions /> : <StaffLogin />
          }
        />

        <Route
          path="/administrator/runrocket/templates/manage"
          element={
            staff ? <AdminManageRunrocketTrainingTemplate /> : <StaffLogin />
          }
        />
        <Route
          path="/administrator/runrocket/templates/training/:template_id"
          element={
            staff ? (
              <AdminManageRunrocketTrainingTemplateData />
            ) : (
              <StaffLogin />
            )
          }
        />

        <Route
          path="/administrator/runrocket/templates/edit-set/:set_id"
          element={staff ? <AdminRunrocketTrainingDataEdit /> : <StaffLogin />}
        />

        <Route
          path="/administrator/athlete/loadvelocity/test-results/:athlete_id"
          element={
            staff ? (
              <AdminAthleteLoadvelocityTestTransactions />
            ) : (
              <StaffLogin />
            )
          }
        />

        <Route
          path="/administrator/loadvelocity/templates/manage"
          element={
            staff ? <AdminManageLoadvelocityTrainingTemplate /> : <StaffLogin />
          }
        />
        <Route
          path="/administrator/loadvelocity/templates/training/:template_id"
          element={
            staff ? (
              <AdminManageLoadvelocityTrainingTemplateData />
            ) : (
              <StaffLogin />
            )
          }
        />

        <Route
          path="/administrator/loadvelocity/templates/edit-set/:set_id"
          element={
            staff ? <AdminLoadvelocityTrainingDataEdit /> : <StaffLogin />
          }
        />

        <Route
          path="/administrator/coach/payment-transactions/:coach_id"
          element={staff ? <AdminCoachPaymentTransactions /> : <StaffLogin />}
        />

        <Route
          path="/administrator/coach/runrocket/test-results/:coach_id"
          element={staff ? <CoachAdminRunrocketTestResult /> : <StaffLogin />}
        />

        <Route
          path="/administrator/coach/loadvelocity/test-results/:coach_id"
          element={
            staff ? <CoachAdminLoadvelocityTestResult /> : <StaffLogin />
          }
        />

        <Route
          path="/administrator/coach/edit/:coach_id"
          element={staff ? <AdminCoachEdit /> : <StaffLogin />}
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
